import _ from 'lodash'
import { FetchDataUtil } from '@vzmi/component_ec_nodejs_util'
import { idsParser } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import safeAwait from '../../../../lib/safeAwait'
import errorHelper from '../../../../lib/errorHelper'

const FIELDS_KEY = 'fields'
const MAX_REQUEST_SIZE = 200
const DEFAULT_REQUEST_SIZE = 50

// 取得批次提案的賣場資料
const fetchBatchListings = async (actions, params) => {
  const { fetchListings } = actions
  const paramsWithFields = { ...params, limit: DEFAULT_REQUEST_SIZE, maxResults: MAX_REQUEST_SIZE }
  if (_.isEmpty(params[FIELDS_KEY])) {
    // 如果沒有帶 fields 欄位，預設當作不過濾賣場欄位，
    // 所以會把 get listing 可以列出的的欄位全部列出
    paramsWithFields[FIELDS_KEY] = ''
  }
  const [error, payload] = await safeAwait(
    FetchDataUtil.fetchAllPages(fetchListings, {
      payload: paramsWithFields,
      selector: res => _.get(res, 'listings', [])
    })
  )
  const errorMessage = errorHelper.parseErrorMessage(error)
  if (errorMessage) {
    return [{ message: errorMessage, params: paramsWithFields }]
  }
  const sortedListingsFromParams = _.flow(
    // 從 API 回應取得賣場
    () => _.get(payload, 'data', []),
    // 以賣場編號組成 map
    listings => _.keyBy(listings, 'id'),
    // 以查詢參數的賣場編號順序重新排序賣場
    listingMapById => _.map(idsParser(params.id), id => _.get(listingMapById, id)),
    // 過濾掉沒有查到的賣場
    sortedListings => _.filter(sortedListings, listing => !_.isEmpty(listing))
  )()

  return [undefined, sortedListingsFromParams]
}

export default fetchBatchListings
